export var DEFAULT_CHAR_LIMIT = 360;
export var DEFAULT_SEE_MORE = 'See more';
export var DEFAULT_SEE_LESS = 'See less';